var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"form-input",class:_vm.invalid ? [_vm.addclass, 'invalid-input'] : _vm.addclass,attrs:{"placeholder":_vm.placeholder,"type":"text"},on:{"input":_vm.checkValue}},'input',{id: _vm.idname},false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd085c50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ImaskInput.vue
// module id = 125
// module chunks = 0